import { AuthenticationService, AuthorizationGuard } from '@pwc-bei/security';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { map } from 'rxjs';
import { User } from '@pwc-bei/common';
import { UserTypeEnum } from './enum/user-type.enum';

@Injectable({ providedIn: 'root' })
export class LegalRepresentativeGuard implements CanActivate, CanActivateChild {
  constructor(private authenticationService: AuthenticationService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canProceed(next);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(childRoute, state);
  }

  canProceed(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    if (!environment.configuration.showPrivacy) {
      return of(true);
    }

    return this.authenticationService.dataUser().pipe(
      map((user: User) => {
        if ((user.userType as UserTypeEnum) === 'LEGAL_REPRESENTATIVE') {
          return true;
        }
        return false;
      }),
    );
  }
}
